//首页
const home = () => import('@/views/home');
//证书搜索页
const searchCer = () => import('@/views/searchCer');
//搜索框
const searchList = () => import('@/views/searchList');
//部门概况
const department = () => import('@/views/department');
//联系我们
const contactUs = () => import('@/views/contactUs');
//培训案列
const case1 = () => import('@/views/case');
//图片详情
const imgDetail = () => import('@/views/imgDetail');


const routes = [
    {
	    path: '/',
	    name: "home",
	    component: home,
	    meta: {
	        title: '四川大学继续教育学院教育培训'
	    }
	},
	{
	    path: '/searchCer',
	    name: "searchCer",
	    component: searchCer,
	    meta: {
	        title: '四川大学继续教育学院教育培训'
	    }
	},
	{
	    path: '/searchList',
	    name: "searchList",
	    component: searchList,
	    meta: {
	        title: '四川大学继续教育学院教育培训'
	    }
	},
	{
	    path: '/department',
	    name: "department",
	    component: department,
	    meta: {
	        title: '四川大学继续教育学院教育培训'
	    }
	},
	{
	    path: '/contactUs',
	    name: "contactUs",
	    component: contactUs,
	    meta: {
	        title: '四川大学继续教育学院教育培训'
	    }
	},
	{
	    path: '/case',
	    name: "case",
	    component: case1,
	    meta: {
	        title: '四川大学继续教育学院教育培训'
	    }
	},
	{
	    path: '/imgDetail',
	    name: "imgDetail",
	    component: imgDetail,
	    meta: {
	        title: '四川大学继续教育学院教育培训'
	    }
	}
]
export default routes;